import { JSX, PropsWithChildren } from 'react';

export enum PowerUnits {
  WH = 'Wh',
  KWH = 'kWh',
  MWH = 'MWh',
}
export enum TimeUnits {
  Y = 'y',
  MO = 'mo',
  W = 'w',
  D = 'd',
  H = 'h',
  MIN = 'min',
  S = 's',
}

enum OtherUnit {
  J = 'J',
  KJ = 'kJ',
  CAL = 'cal',
  KCAL = 'kcal',
  BTU = 'BTU',
  USD = 'USD',
  MILES = 'miles',
  POUNDS = 'lbs',
  PERCENT = '%',
}

export type Unit = PowerUnits | TimeUnits | OtherUnit;

export interface IKPIWidget extends PropsWithChildren<any> {
  value: number;
  unit: Unit;
  title: string;
  compareValue?: number;
  animated: boolean;
  infoMessage: string;
  isLoading: boolean;
  error?: boolean;
  icon?: JSX.Element;
  compare?: boolean;
}
